import type { FieldDef } from "@/components/wizard/field-list";
import { PRETENSAO_OUTRO } from "@/lib/labels/lead-instagram";

export interface Draft {
	name?: string;
	phone?: string;
	age?: string;
	city?: string;
	pretensao?: string;
	pretensao_detail?: string;
}

export type FieldKind = "text" | "tel" | "number" | "chips";
export type InstagramField = FieldDef<Draft, FieldKind>;

export const FIELDS: InstagramField[] = [
	{ key: "name", label: "Seu nome", kind: "text" },
	{ key: "phone", label: "Seu WhatsApp", kind: "tel" },
	{ key: "pretensao", label: "Procedimento desejado", kind: "chips" },
	{
		key: "pretensao_detail",
		label: "Procedimento desejado",
		kind: "text",
		condition: (d) => d.pretensao === PRETENSAO_OUTRO,
	},
	{ key: "age", label: "Sua idade", kind: "number", optional: true },
	{ key: "city", label: "Sua cidade", kind: "text", optional: true },
];
